import { render } from "./homeItem.vue?vue&type=template&id=40fe3113"
import script from "./homeItem.vue?vue&type=script&lang=js"
export * from "./homeItem.vue?vue&type=script&lang=js"

import "./homeItem.vue?vue&type=style&index=0&id=40fe3113&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__